export default {
  defaultSortField: 'nestedLocation',
  defaultSortOrder: 'desc',
  rearrangeCols: false,
  isCheckable: true,
  isRowCheckable(row) {
    return !row.nestedLocation;
  },
  gutterOpts: {
    buttons: [],
  },
  toolBar: {
    searchPlaceHolder: 'Search Locations',
    bulkActions: () => [
      {
        name: 'Delete Locations',
        event: 'deleteLocations',
        label: 'Delete',
      },
    ],
    buttons: [
      {
        event: 'openActivity',
        icon: 'icon-activityhistory',
        tooltip: 'Activity History',
        isLine: true,
			},
      {
        event: 'addNew',
        icon: 'icon-addnew',
        isLine: true,
        tooltip: 'New',
        permissionModule: 'app&projects',
        alterDataKey: 'companyLocations',
      },
      {
        event: 'excelImport',
        icon: 'icon-importexcel',
        isLine: true,
        tooltip: 'Import From Excel',
        permissionModule: 'app&projects',
        alterDataKey: 'companyLocations',
      },
    ],
  },
  fields: [

    {
      alwaysVisible: true,
      sticky: true,
      name: 'nested-icon',
      width: '40px',
      id: 'nested-icon',
      prop: 'nested-icon',
      title: '',
    },
    {
      name: 'name',
      prop: 'name',
      sortField: 'name',
      width: '320px',
      title: 'Location Name',
      id: 'name',
      fieldName: 'name',
      isNested: true,
      searchable: true,
    }, {
      name: 'owner',
      prop: 'owner',
      fieldName: 'owner',
      sortField: 'owner',
      width: '256px',
      title: 'Owner',
      id: 'owner',
    }, {
      name: 'street',
      prop: 'street',
      fieldName: 'street',
      sortField: 'street',
      width: '152px',
      title: 'Street',
      id: 'street',
    }, {
      name: 'city',
      prop: 'city',
      fieldName: 'city',
      sortField: 'city',
      width: '152px',
      title: 'City',
      id: 'city',
    }, {
      name: 'state',
      prop: 'state',
      fieldName: 'state',
      sortField: 'state',
      width: '152px',
      title: 'State',
      id: 'state',
    }, {
      name: 'zip',
      fieldName: 'zip',
      prop: 'zip',
      sortField: 'zip',
      width: '152px',
      title: 'Zip',
      id: 'zip',
    }, {
      name: 'location_type',
      prop: 'location_type',
      fieldName: 'location_type',
      defaultValue: 'Rental',
      sortField: 'location_type',
      width: '152px',
      title: 'Type',
      id: 'location_type',
    },
    {
      name: 'defaultInventoryLocation',
      title: 'Project Inventory Default',
      prop: 'defaultInventoryLocation',
      id: 'default_location',
      width: '256px',
    },
    {
      name: 'table-field-actions',
      width: '112px',
      id: 'action',
      title: 'Action',
      permissionModule: 'app&projects',
      permissionKey: 'company_locations',
      hideFromChooser: true,
      alwaysVisible: true,
      defaultVisible: true,
      inputProps: {
        showEdit: false,
        groupButtons(rowData) {
          return [
            {
              icon: 'icon-edit',
              event: 'edit',
              tooltip: 'Edit Location',
              permissionModule: 'app&projects',
              alterDataKey: 'companyLocations',
            },
          ];
        },
      },
    },
  ]
}